import React, { Component } from "react";
import VectorSource from "ol/source/Vector";
import VectorLayer from "ol/layer/Vector";
import TileArcGISRest from "ol/source/TileArcGISRest";
import {Draw, Modify, Snap} from 'ol/interaction';

import VectorTileSource from "ol/source/VectorTile";
import VectorTileLayer from "ol/layer/VectorTile";
import { createXYZ } from "ol/tilegrid";
import TileWMS from 'ol/source/TileWMS';
import olTileLayer from "ol/layer/Tile";
import olSourceXYZ from "ol/source/XYZ";

import { Style, Text, Fill, Stroke, Circle } from "ol/style.js";
import WKT from "ol/format/WKT.js";

class DrawingOverlay extends Component {

  state = {
    vectorSource: null,
    vectorLayer: null,
    isLoaded: false
  };

  componentDidMount() {
    
  }

  componentDidUpdate() {
    const { map, enabled, vectorSource } = this.props;
    if(!this.state.isLoaded) {
      
      const modify = new Modify({source: vectorSource});
      

      let draw = new Draw({
        source: vectorSource,
        type: 'Polygon',
      });

      draw.on('drawstart', function () {
        //var feature = event.feature;
        vectorSource.clear();
        //vectorSource.addFeature(feature);
      });
      
      let snap = new Snap({source: vectorSource});

      const vector = new VectorLayer({
        source: vectorSource,
        style: new Style({
          fill: new Fill({
            color: 'rgba(252, 127, 3, 0.5)',
          }),
          stroke: new Stroke({
            color: 'rgb(252, 127, 3)',
            width: 2,
          }),
        }),
      });

      map.addLayer(
        vector
      );
      
      this.setState({
        isLoaded: true,
        vectorSource: vectorSource,
        vectorLayer: vector,
        modifyInteraction: modify,
        drawInteraction: draw,
        snapInteraction: snap
      });

      

    } else if(!!enabled) {
      map.addInteraction(this.state.modifyInteraction);
      map.addInteraction(this.state.drawInteraction);
      map.addInteraction(this.state.snapInteraction);
    } else {
      map.removeInteraction(this.state.modifyInteraction);
      map.removeInteraction(this.state.drawInteraction);
      map.removeInteraction(this.state.snapInteraction);
    }
  };

  render() {
    return false;
  }
}


export default DrawingOverlay;
